import { render, staticRenderFns } from "./EditTableTwo.vue?vue&type=template&id=3c646500&scoped=true&"
import script from "./EditTableTwo.vue?vue&type=script&lang=js&"
export * from "./EditTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./EditTableTwo.vue?vue&type=style&index=0&id=3c646500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c646500",
  null
  
)

export default component.exports